import template from './customer-details.html';
import controller from './customer-details.controller';

let customerDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default customerDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/customer-details/customer-details.component.js